module.exports = __webpack_public_path__ + "img/7_16.2d987ecf.png";